import { IGetState, TBoardId } from '../../../../../../../../types/types';
import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import {
    removePrefixes
} from '../../../../../boardDetails/details/CardNumber/hocs/PrefixesSectionHOC/effects/removePrefixes';
import { getAuthUser } from '../../../../../../../../store/model/authUser/selectors/getAuthUser';
import { SegmentCardEvent, segmentTrackAction } from '../../../../../../../../middlewares/segment';
import { showSnoozeBlocker } from '../../../../../../base/effects/showSnoozeBlocker';

export const onCardNumberRemoveAll = (
    boardId: TBoardId,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const { allowCardNumber } = getAuthUser(getState());
        if (allowCardNumber) {
            dispatch(segmentTrackAction(SegmentCardEvent.CARD_PREFIX_DELETED));
            return dispatch(removePrefixes(boardId));
        } else {
            return dispatch(showSnoozeBlocker({ allow: 'allowCardNumber' }));
        }
    };
    return action;
};
